export enum RemoteButtonKey {
  center = 'center',
  'center-hisense' = 'center-hisense',
  back = 'back',
  home = 'home',
  youtube = 'youtube',
  voice = 'voice',
  netflix = 'netflix',
  up = 'up',
  down = 'down',
  left = 'left',
  right = 'right',
}

export type RemoteButtonKeyCode = keyof typeof RemoteButtonKey;
